<template>
  <div>
    <v-card>
      <v-card-actions class="pl-3 pr-3 pt-3 pb-3">
        <v-btn variant="flat" size="large" class="pl-2 pr-2" @click="exportJson()">Download JSON file</v-btn>
        <v-btn variant="outlined" size="large" class="pl-2 pr-2" @click="closeDialog()">Cancel</v-btn>
      </v-card-actions>
      <v-card-text>
        <pre class="ma-5 pa-5">{{ jsonData }}</pre>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { downloadFile } from '@/utils/fsUtils'
import { sanitizeFilename } from '@/utils/sanitize'
import { cardHelpers } from '@/mixins/cardHelpers.js'

export default {
  props: ['workflow'],
  mixins: [cardHelpers],
  data () {
    return {}
  },
  methods: {
    exportJson () {
      try {
        const data = this.prepareForExport()
        downloadFile(
          sanitizeFilename(this.workflow.name, 'json'),
          'application/json',
          JSON.stringify(data, null, 2)
        )
      } catch (error) {
        console.error('Error exporting JSON:', error)
      }
    },
    prepareForExport () {
      const emptyCardArrayFields = ['attachments', 'comments', 'reactions', 'tags']
      const workflow = this.removeAttributes(this.workflow)

      if (workflow?.domainEvents) {
        for (const event of workflow.domainEvents) {
          if (event.cards) {
            for (const card of event.cards) {
              if (card.cardType) {
                card.domainModelRole = card.cardType.domainModelRole
                delete card.cardType
              }
              for (const field of emptyCardArrayFields) {
                if (Array.isArray(card[field]) && !card[field].length) {
                  delete card[field]
                }
              }
            }
          }
        }
      }

      return { workflow, cardTypes: this.cardTypes }
    },
    closeDialog () {
      this.$emit('closeExportJsonDialog')
    },
    removeAttributes (obj, attributeNames = ['version', 'updateNote', 'teamMembers']) {
      const attributesToRemove = [...attributeNames]

      if (obj === null || obj === undefined) {
        return undefined
      }

      if (Array.isArray(obj)) {
        return obj
          .map((item) => this.removeAttributes(item, attributeNames))
          .filter((item) => item !== undefined)
      }

      if (typeof obj === 'object') {
        const newObj = {}
        for (const key of Object.keys(obj)) {
          if (attributesToRemove.includes(key)) {
            continue
          }
          const cleanedValue = this.removeAttributes(obj[key], attributeNames)
          if (cleanedValue !== undefined) {
            newObj[key] = cleanedValue
          }
        }

        return Object.keys(newObj).length > 0 ? newObj : undefined
      }

      if (obj === '') {
        return undefined
      }

      return obj
    }
  },
  computed: {
    ...mapState({
      cardTypes: state => state.cardTypes.cardTypes
    }),
    jsonData () {
      return JSON.stringify(this.prepareForExport(), null, 4)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  padding: 1em;
  color: #444;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 0.3em 0.5em;
  border: 1px solid var(--light-4);
}

.dl dt {
  float: left;
  color: #999;
}

html, body, textarea {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: 100%;
}

textarea {
  vertical-align: top;
}
</style>
